import { css } from "@emotion/css";

const styles = {
  content: (isMobile) => css`
    height: ${isMobile ? "calc(100vh - 50px)" : "100vh"};
  `,
};

export default styles;
